/** Copied from src/client/components/OfferPage/AlwaysOn/AlwaysOnStickyHeader.tsx walled content login & signup buttons */
import { accountAccessShowLogin } from 'actions/UiActions'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import { mediaQueryDown, mediaQueryUp } from 'components/utils/breakpoint'
import { useAppDispatch } from 'hooks/reduxHooks'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const InlineWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > * + * {
    margin-left: ${rem(8)};
  }

  ${mediaQueryUp.tablet} {
    justify-content: flex-end;
  }
`

const AuthButtonsWrapper = styled.div`
  display: flex;
  align-items: center;

  & > * + * {
    margin-left: ${rem(8)};
  }
`

const MobileNewLine = styled.br`
  ${mediaQueryUp.tablet} {
    display: none;
  }
`
const HideOnMobile = styled.span`
  ${mediaQueryDown.tablet} {
    display: none;
  }
`

export default function GenericLoginSignupWall() {
  const authDispatch = useAppDispatch()

  return (
    <InlineWrapper>
      <BodyText weight="bold" variant="small">Join now to view <MobileNewLine /> member prices</BodyText>
      <AuthButtonsWrapper>
        <TextButton kind="secondary" onClick={() => authDispatch(accountAccessShowLogin())}>
          Log In
        </TextButton>
        <TextButton kind="primary" onClick={() => authDispatch(accountAccessShowLogin())}>
          Sign up <HideOnMobile>&nbsp;for free</HideOnMobile>
        </TextButton>
      </AuthButtonsWrapper>
    </InlineWrapper>
  )
}
